import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {UserService} from '../../../services/user/user.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth/auth.service';
import {LangSrc} from '../../../interfaces/lang-src';
import {LangTgt} from '../../../interfaces/lang-tgt';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-learning-modal-same-language',
    standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
    templateUrl: './learning-modal-same-language.component.html',
    styleUrls: ['./learning-modal-same-language.component.scss']
})
export class LearningModalSameLanguageComponent implements OnInit {

    form: FormGroup;
    user: any;
    loading = false;
    languages: LangSrc[];
    @Input() langTgt: LangTgt;

    constructor(
        private modal: NgbActiveModal,
        private authSrv: AuthService,
        private userService: UserService,
        public langSrcSrv: LangSrcService,
    ) {
        this.form = new FormGroup({
            idLangSrc: new FormControl(null, [Validators.required])
        });
    }

    async ngOnInit() {
        this.languages = this.langSrcSrv.langs.filter(x => x.shortCode !== this.langSrcSrv.current.shortCode);
        this.user = await this.authSrv.getUser();
        this.form.get('idLangSrc').setValue(this.languages[0].id);
    }

    trackById(index: number, item: any) { return item.id; }

    close() {
        this.modal.close(false);
    }

    async onSubmit() {

        this.loading = true;

        // get language by id
        const langSrc = this.langSrcSrv.langs.find(x => x.id === parseInt(this.form.value.idLangSrc, 0));

        // same language
        if (langSrc.id === this.user.langSrc.id) {
            this.close();
            return;
        }

        // update account preferences
        await this.userService.updateLanguage(langSrc);

        // refresh user
        await this.authSrv.storeUser();

        // change current language
        await this.langSrcSrv.setCurrent(langSrc);

        // close modal
        this.modal.close(true);
    }

}
